import type { TextSize } from "../storage/local";

/** The three steps of kit §40, in the order the Segmented shows them. */
export const TEXT_SIZES: { value: TextSize; label: string }[] = [
  { value: "normal", label: "Normal" },
  { value: "large", label: "Large" },
  { value: "larger", label: "Larger" },
];

/** What the You hub's Display row says it is set to. */
export const TEXT_SIZE_LABEL: Record<TextSize, string> = {
  normal: "Normal text",
  large: "Large text",
  larger: "Larger text",
};
